import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import {SnippetSelectionInputArea} from './SnippetSelectionInputArea.react';

const SnippetSelectionQuestionComponent = ({
  actions,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  customHeader,
  displayOrientation = 'default',
  guess,
  hasQuestionSetAccessPredicate,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  postSubmissionScrollPointRef,
  showDifficulty,
  questionState
}: QuestionComponentProps) => {
  return (
    <QuestionComponent
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      activeSubject={activeSubject}
      customHeader={customHeader}
      displayOrientation={displayOrientation}
      guess={guess}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
      headingActions={headingActions}
      interactive={interactive}
      isMobile={isMobile}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      questionState={questionState}
      showDifficulty={showDifficulty}
      ActiveQuestionInputArea={SnippetSelectionInputArea}
    />
  );
};

type SnippetSelectionQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const SnippetSelectionQuestion = {
  PreGuess: (props: SnippetSelectionQuestionTypeProps) => (
    <SnippetSelectionQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: SnippetSelectionQuestionTypeProps) => (
    <SnippetSelectionQuestionComponent {...props} questionState='PostGuess' />
  )
};

export {SnippetSelectionQuestion};
